import { IssueWizardProps, SetableIssueFields } from './types';
import { ProcessType } from 'shared/domain/process/types/model';
import { toLabelledEntity } from 'components/inspection/Form/model';
import { findById } from 'shared/utils/id/findById';
import { VisibleFieldModel } from 'shared/domain/visibleField/visibleFieldModel';
import { IssueFieldNames } from 'shared/domain/issueForm/types/fieldNames';
import {
  nowTimezonedDateTime,
  setDayStart,
} from '../../../shared/utils/date/dates';
import { DateTime } from 'luxon';

const emptyIssue: SetableIssueFields = {
  process: undefined,
  site: undefined,
  level: undefined,
  title: undefined,
};

export function resolveInspectionIssueProcess(
  processes: ProcessType[],
  processId: IssueWizardProps['processId'],
  processCode: IssueWizardProps['processCode']
): ProcessType | undefined {
  if (processId) {
    const byId = findById(processes, processId, 'inspection issue wizard process');
    if (byId) {
      return byId;
    }
  }

  if (processCode) {
    return processes.find((process) => process.code === processCode);
  }

  return undefined;
}

export function createInitialValues(
  initialValues: IssueWizardProps['initialValues'],
  processId: IssueWizardProps['processId'],
  processCode: IssueWizardProps['processCode'],
  processes: ProcessType[]
): SetableIssueFields {
  if (initialValues) {
    const matchingProcess = resolveInspectionIssueProcess(
      processes,
      processId,
      processCode
    );

    const { site, level } = initialValues;

    return {
      ...emptyIssue,
      site,
      level,
      process: matchingProcess
        ? toLabelledEntity(matchingProcess)
        : undefined,
    };
  } else {
    return emptyIssue;
  }
}

/** The start of today when the process shows the detection date. */
export function addDetectionDate(
  visibleFieldsOfProcess: VisibleFieldModel[],
  timezone: string
): DateTime | undefined {
  const detectionDateField = visibleFieldsOfProcess.find(
    (field) => field.fieldName === IssueFieldNames.detectionDate
  );
  if (detectionDateField)
    return setDayStart(nowTimezonedDateTime(timezone));

  return undefined;
}
